import { render, staticRenderFns } from "./BLCRemodal.vue?vue&type=template&id=5e058c2e&scoped=true&lang=pug&"
import script from "./BLCRemodal.vue?vue&type=script&lang=js&"
export * from "./BLCRemodal.vue?vue&type=script&lang=js&"
import style0 from "./BLCRemodal.vue?vue&type=style&index=0&id=5e058c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e058c2e",
  null
  
)

export default component.exports